// extracted by mini-css-extract-plugin
export default {"sectionsWrapper":"Sections_sectionsWrapper__rziAD","pageTitle":"Sections_pageTitle__A3954","buttonLink":"Sections_buttonLink__mnK0P"};